/**
 * Cookie utility functions for handling browser cookies consistently across the application
 */

/**
 * Set a cookie with advanced options including timestamps and expiration handling
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration (optional)
 */
export const setCookie = (name, value, days) => {
  let cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;

  if (days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookie += `; expires=${expires.toUTCString()}`;
  }

  // Add Secure only if running on https
  if (window.location.protocol === 'https:') {
    cookie += '; Secure';
  }

  document.cookie = cookie;
};

/**
 * Get a cookie value with automatic expiration checking and JSON parsing
 * @param {string} name - Cookie name to retrieve
 * @returns {Object|null} Cookie data object with value and timestamp, or null if not found/expired
 */
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let c of cookies) {
    c = c.trim();
    if (c.startsWith(nameEQ)) {
      return decodeURIComponent(c.substring(nameEQ.length));
    }
  }

  return null; // not found
};

/**
 * Delete a cookie by setting it to expire in the past
 * Tries multiple variations to ensure complete removal
 * @param {string} name - Cookie name to delete
 */
export const deleteCookie = (name) => {
  // Delete with multiple path and domain variations to ensure complete removal
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure;`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
};


/**
 * Clear multiple cookies at once
 * @param {string[]} cookieNames - Array of cookie names to delete
 */
export const clearCookies = (cookieNames) => {
  cookieNames.forEach(cookieName => {
    deleteCookie(cookieName);
  });
};
